import { systemCode, xs_languageCode } from "..";
import { getLabel } from "../InitData";
import { filterSportMenu, getMainAgg, getUrlPathSeo, getUrlPathSeoLive, getUrlPathSeoSettings, parseScore } from "./data";
import { parseAdditionalData } from "./parseAdditionalData";
import { parseBetsData } from "./parseBetsData";
import parseJerseys from "./parseJerseys";
import { formatDate, getConfiguration, getLiveAggs, getPrincipaleOPrimoGruppo, getRanking, getSplitDesc, iconCategoryCssClass } from "./utils";

function byRanking(a, b) {
    if (a.rks?.[systemCode] != null && b.rks?.[systemCode] != null) {
        return a.rks[systemCode] - b.rks[systemCode];
    }
    return a.ranking - b.ranking;
}

function byTimestamp(a, b) {
    return a.timestamp - b.timestamp;
}

function byDesc(a,b) {
    return a.desc.localeCompare(b.desc);
}

function byTimestampOrDesc(a, b) {
    return byTimestamp(a, b) || byDesc(a, b);
}

function parseEvents(events, sportId, sportDesc, categoryDesc, descTournament, compattaParametriche, aggregate, tournament) {
    function getUrlPath(tournament, match, desc) {
        desc = desc?.replace(/-/g, 'vs').replace(/\s+/g, '-').replace(/\//g, '-');
        const url = `${tournament?.urlPath}/${desc}_${tournament?.uniqueId}_${match?.p}_${match?.a}`;
        return url?.toLocaleLowerCase();
    }

    const parsedEvents = [];
    events.forEach(function(event) {
        const arrayAggr = [];
        aggregate.forEach(aggId => {
            const agg = getLiveAggs(sportId, aggId);
            if (agg != null) {
                arrayAggr.push(agg);
            }
        });
        const aggrPrincipale = getPrincipaleOPrimoGruppo(arrayAggr);
        const desc = event.dsl[xs_languageCode];
        const matchData = {
            id: event.bid,
            pal: event.p,
            avv: event.a,
            alias: event.al,
            desc,
            uniqueId: event.bid,
            sportDesc: sportDesc,
            categoryDesc,
            tournamentDesc: descTournament,
            sportRef: sportId,
            tournamentRef : event.it,
            timestamp : event.ts,
            str: event.str,
            widgetType: event.wty,
            geniusId: event.gid,
            lsportWidgetId: event.lswid
        };
        const betsData = parseBetsData(matchData, aggregate, aggrPrincipale.idAggregata, event.scs, true, compattaParametriche);
        betsData.giocabilita = event.sh && event.scs.length > 0;

        if (betsData.gruppiScommessa?.[0]?.scommesse?.[0] != null) {
            const [team1, team2] = getSplitDesc(desc);
            const date = formatDate(event.ts);
            
            parsedEvents.push({
                id: event.bid,
                competitorIdHome: event.cidh,
                competitorIdAway: event.cida,
                pal: event.p,
                avv: event.a,
                alias: event.al,
                plus: event.pl,
                plusByAggregateId : event.plba,
                desc,
                sportDesc: sportDesc,
                categoryDesc,
                tournamentDesc: descTournament,
                team1,
                team2,
                time: formatDate(event.ts).time,
                timestamp: new Date(date.year, date.month - 1, date.day, date.hours, date.minutes, date.seconds),
                timestampDB: event.ts,
                urlWidget: '',
                urlStats: '',
                score: parseScore(event.scr, sportId),
                str: event.str,
                round: event.r,
                widgetType: event.wty,
                geniusId: event.gid,
                lsportWidgetId: event.lswid,
                jerseys: parseJerseys(event.j, sportId),
                info: event.v,
                urlPath: getUrlPath(tournament, event, desc),
                urlPathSeo: getUrlPathSeo({...event,seoSettings:event.seo}),
                urlPathSeoSettings: getUrlPathSeoSettings({...event,seoSettingsAdds:event.seoa}),
                ...betsData
            });
        }
    });

    return parsedEvents.sort(byTimestampOrDesc);
}

function parseTournaments(tournaments, sportId, sportDesc, categoryDesc, iconClass, categoryIcon, categoryRanking, categoryId) {
    const parsedTournaments = [];
    tournaments.forEach(tournament => {
        const filteredMatches = tournament.el.filter(e => {
            let keepIt = e.lv === true && e.sh === true;
            if (keepIt) {     
                const keyMapSkinCode = systemCode;
                let keyMapGroupCode = null;
                let keyMapShopCode = null;
                if(window.appConfig.TERMINAL_AGENCY){
                    const operator = window.getLoggedParamsFromLS();
                    if(operator){
                        if(operator.groupId){
                            keyMapGroupCode = "GRP-" + operator.groupId;
                        }
                        const servicesMap = operator.servicesMap? operator.servicesMap : operator.hash_servizi;
                        const cnPvend = servicesMap['SPORT'];
                        if(cnPvend){
                            const cn = cnPvend.split("/")[0];
                            const pvend = cnPvend.split("/")[1];
                            keyMapShopCode = cn + "_" + pvend;
                        }
                    }
                }
                else if(window.appConfig.SELF_CASHIER){
                    const cashier = window.getVoucherParamsFromLS();
                      if(cashier){
                        if(cashier.groupId){
                            keyMapGroupCode = "GRP-" + cashier.groupId;
                        }
                        const servicesMap = cashier.servicesMap? cashier.servicesMap : cashier.hash_servizi;
                        const cnPvend = servicesMap['SPORT'];
                        if(cnPvend){
                            const cn = cnPvend.split("/")[0];
                            const pvend = cnPvend.split("/")[1];
                            keyMapShopCode = cn + "_" + pvend;
                        }
                    }
                }
                
                
                const stateMap = e.csm? e.csm : {};
                let stateCustom = null;
                //high priority: shop
                if(keyMapShopCode && stateMap[keyMapShopCode] !== null){
                    stateCustom = stateMap[keyMapShopCode];
                }
                
                // less priority: group of this shop
                if(keyMapGroupCode && stateMap[keyMapGroupCode] !== null && !stateCustom){
                    stateCustom = stateMap[keyMapGroupCode];
                }
                // lowest priority: skin customization
                if(stateMap[keyMapSkinCode] !== null && !stateCustom){
                    stateCustom = stateMap[keyMapSkinCode];
                }
                   keepIt = stateCustom !== 'CL';
            }
            return keepIt; 
        });

        if (filteredMatches.length > 0) {
            // Check that the main aggregate is present, otherwise force it as the first
            const mainAgg = getMainAgg(true, filteredMatches[0].is);
            if (mainAgg != null && !tournament.ags.includes(mainAgg.idAggregata)) {
                tournament.ags = [mainAgg.idAggregata, ...tournament.ags];
            }
            try {
                tournament.uniqueId = `${sportId}_${categoryId}_${tournament.id}`;
            }catch(err) {
                console.error(err);
            }
            
            const events = parseEvents(filteredMatches, sportId, sportDesc, categoryDesc, tournament.dsl[xs_languageCode], false, tournament.ags, tournament);
            const aggregate = [];
            tournament.ags.forEach(aggId => {
                const agg = getLiveAggs(sportId, aggId);
                if (agg) {
                    aggregate.push(agg);
                }
            })
            aggregate.sort(byRanking);
            parsedTournaments.push({
                id: tournament.id,
                descrizione: tournament.dsl[xs_languageCode],
                ranking: getRanking(tournament, true),
                categoryRanking,
                isLive: true,
                eventsCount: tournament.ne,
                events,
                iconClass,
                categoryIcon,
                aggregate,
                seasonId: tournament.sid,
                additionalData: parseAdditionalData(tournament.add)
            });
        }
    });
    
    return parsedTournaments.sort(byRanking);
}

function parseCategories(categories, sportId, sportDesc, holdAllTournaments = false) {
    let result = [];
    let allTournaments = [];
    let allTournamentsNe = 0;
    const conf = getConfiguration();
    categories.forEach(category => {
        const ranking = getRanking(category, true);
        const categoryDesc = category.dsl[xs_languageCode];
        const categoryIcon = iconCategoryCssClass(sportId, category.id, category.ic);
        const tournaments = parseTournaments(category.tns, sportId, sportDesc, categoryDesc, category.ic, categoryIcon, ranking, category.id);
        if (tournaments.length > 0) {
            allTournaments = allTournaments.concat(tournaments);
            allTournamentsNe += category.ne;
            result.push({
                id: category.id,
                descrizione: categoryDesc,
                ranking,
                isLive: true,
                tournamentsCount: category.ne,
                tournaments,
                iconClass: category.ic,
                categoryIcon
            });
        }
    });

    allTournaments.sort((a, b) => {
        // Both tournaments have the same category ranking, sort them by ranking
        if (a.categoryRanking === b.categoryRanking) {
            return a.ranking - b.ranking;
        } else {
            // Sort by category ranking
            return a.categoryRanking - b.categoryRanking;
        }
    });

    if (categories.length > 1 && holdAllTournaments) {
        const liveSuiteTournamentSorting = conf.lsts;
        const sportWhitelisted = !liveSuiteTournamentSorting?.sp || liveSuiteTournamentSorting?.sp[sportId];
        if(liveSuiteTournamentSorting?.en && allTournaments.length > liveSuiteTournamentSorting?.lowt && sportWhitelisted){
			/*
			 Reorder tournaments:
			 for first, the tournaments with high priority in each category (so the first tournament in each category, because they are already sorted by ranking)
			 for second, the tournaments in second position by ranking (the second ones in the native tournament list)
			 and so on
			 Example:
			 Italy Serie A, Italy Serie B, Italy Serie C, England Premier League, England Championship
			 WILL BE SORTED AS:
			 Serie A, Premier League, Serie B, Championship, Serie C
			*/
			const tournamentsMap = []; // array of arrays
	        for(let kc in result){
	        	const sourceCategory = result[kc];
	        	const sourceTournaments = sourceCategory.tournaments;
	        	for(let kt = 0; kt < sourceTournaments.length; kt ++){
	        		const tournament = sourceTournaments[kt];
	        		//const matrixKey = kt; I will use the tournament ranking as array index, to respect the tournament ranking and not its appearing position
					const matrixKey = tournament.ranking > 0? tournament.ranking : 10000; // 0 means unsetted ranking
					if(!tournamentsMap[matrixKey]){
						tournamentsMap[matrixKey] = [];
					}
					tournamentsMap[matrixKey].push(tournament);
	        	}
	        }
			//allTournaments = topTournaments.concat(others);
			const finalVector = [];
			for(let km in tournamentsMap){
				const tournamentContainer = tournamentsMap[km];
				if(tournamentContainer?.length > 0){
					for(let kt in tournamentContainer){
						finalVector.push(tournamentContainer[kt]);
					}				
				}

			}     
			allTournaments = finalVector;  
        }

		
        result = result.concat({
            id: 0,
            descrizione: getLabel('general.tutti'),
            ranking: 0,
            isLive: true,
            tournamentsCount: allTournamentsNe,
            tournaments: allTournaments
        });
    }
    
    // Sort categories by ranking (the fake category "All" is always first)
    return result.sort((a, b) => {
        if (a.id === 0) {
            return -1;
        } else {
            return a.ranking - b.ranking;
        }
    });
}

function parseSports(spa, sps, holdAllTournaments = false) {
    if (spa != null) { // Parsing dati menu live generale
        const sp = sps[0];
        return spa.map(s => { // In spa[] elenco degli sport
            const categories = s.id === sp.id ? parseCategories(sp.cts, sp.id, sp.dsl[xs_languageCode], true) : []; // In sps[] solo sport corrente, faccio il parsing solo di questo
            return {
                id: s.id,
                descrizione: s.dsl[xs_languageCode],
                ranking: getRanking(s, true),
                isLive: true,
                eventsCount: s.ne,
                categories,
                iconClass: s.ic,
                urlPath: s.dsl[xs_languageCode]+'_live',
                urlPathSuffix: `_${s.id}`,
                urlPathSeoLive: getUrlPathSeoLive({seoSettingsLive: s.seol})
            };
        }).sort(byRanking);
    } else {  // Parsing dati menu live single match
        return sps.map(s => {
            const desc = s.dsl[xs_languageCode]
            const categories = parseCategories(s.cts, s.id, desc, holdAllTournaments);
            return {
                id: s.id,
                descrizione: desc,
                ranking: getRanking(s, true),
                isLive: true,
                eventsCount: s.ne,
                categories,
                iconClass: s.ic,
                urlPath: s.dsl?.[xs_languageCode]+'_live',
                urlPathSuffix: `_${s.id}`,
                urlPathSeoLive: getUrlPathSeoLive({seoSettingsLive: s.seol})
            };
        }).sort(byRanking);
    }
}

export function parseLiveData(liveData, holdAllTournaments = false) {
    const sports = parseSports(liveData.spa, filterSportMenu(liveData.sps), holdAllTournaments);

    const data = {
        sportById: {},
        categoryByUniqueId: {},
        tournamentByUniqueId: {},
        sport: sports,
        nel: liveData.nel,
        nep: liveData.nep,
        matches: [],
        matchById: new Map()
    };

    data.sport.forEach(sport => {
        data.sportById[sport.id] = sport;
        sport.categories.forEach((category, i) => {
            category.sportRef = sport.id;
            const uniqueId = `${sport.id}_${category.id}`;
            category.uniqueId = uniqueId;
            
            if (i === 0) {
                sport.categoryById = {};
            }
            sport.categoryById[category.id] = category;
            data.categoryByUniqueId[uniqueId] = category;
            category.tournaments.forEach((tournament, j) => {
                tournament.sportRef = sport.id;
                tournament.categoryRef = category.id;
                tournament.categoryDesc = category.descrizione;
                const uniqueId = `${category.uniqueId}_${tournament.id}`;
                tournament.uniqueId = uniqueId;
				
				if (j === 0) {
                    category.tournamentById = {};
                }                
                category.tournamentById[tournament.id] = tournament;
                data.tournamentByUniqueId[uniqueId] = tournament;

                tournament.matchById = {};

                tournament.events.forEach(event => {
                    const uniqueId = `${tournament.uniqueId}_${event.id}`;
                    event.uniqueId = uniqueId;
                    event.sportRef = sport.id;
                    event.categoryRef = category.id;
                    event.tournamentRef = tournament.id;
                    event.isLive = true;
                    event.sportDesc = sport.descrizione;
                    event.tournamentDesc = tournament.descrizione;
                    
                    tournament.matchById[event.id] = event;

                    event.gruppiScommessa.forEach(gruppo => {
                        gruppo.scommesse.forEach(scommessa => {
                            const uniqueId = `${event.uniqueId}_${scommessa.id}_${scommessa.handicap}`;
                            //scommessa.id = uniqueId;
                            scommessa.uniqueId = uniqueId;

                            /*scommessa.odds.forEach(function(odd, i) {
                                odd.id =  `${scommessa.uniqueId}_${odd.id}`;
                            });*/
                        })
                    });

                    data.matches.push(event);
                    data.matchById.set(`${event.pal}_${event.avv}`, event);
                });
            });
        });
    });

    return data;
}
